"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PokerLeaderboardDTO = exports.ChipResetDTO = exports.TicketBalanceChangeDTO = exports.ChipPurchaseDTO = exports.TableMessageDTO = exports.TableGiftDTO = exports.HandDeltaDTO = exports.TableStateChangeDTO = exports.HandActionDTO = exports.HandDealtDTO = exports.HandBeginDTO = exports.BuyInDTO = exports.LeaveTableDTO = exports.JoinTableDTO = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
const enum_1 = require("../types/enum");
const utility_1 = require("../decorators/utility");
const game_related_1 = require("../types/game-related");
let JoinTableDTO = class JoinTableDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.JoinTableDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stakes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "smallBlind", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bigBlind", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialBuyIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "seatNumber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "avatar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], JoinTableDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], JoinTableDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], JoinTableDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], JoinTableDTO.prototype, "gameType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The table stakes e.g. 10|20'),
    __metadata("design:type", String)
], JoinTableDTO.prototype, "stakes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Small blind'),
    __metadata("design:type", Number)
], JoinTableDTO.prototype, "smallBlind", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Big blind'),
    __metadata("design:type", Number)
], JoinTableDTO.prototype, "bigBlind", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The amount each player puts in to join a table'),
    __metadata("design:type", Number)
], JoinTableDTO.prototype, "initialBuyIn", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The seat number for the particular player that joined a table'),
    __metadata("design:type", Number)
], JoinTableDTO.prototype, "seatNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The avatar a player has chosen for their poker player. (*For tracking popularity during beta.*)'),
    __metadata("design:type", String)
], JoinTableDTO.prototype, "avatar", void 0);
JoinTableDTO = __decorate([
    (0, decorators_1.Describe)('Player joins a table')
], JoinTableDTO);
exports.JoinTableDTO = JoinTableDTO;
let LeaveTableDTO = class LeaveTableDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LeaveTableDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chipBalance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], LeaveTableDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], LeaveTableDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], LeaveTableDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], LeaveTableDTO.prototype, "gameType", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The amount of chips a player has remaining leaving a table'),
    __metadata("design:type", Number)
], LeaveTableDTO.prototype, "chipBalance", void 0);
LeaveTableDTO = __decorate([
    (0, decorators_1.Describe)('Player leaves a table.')
], LeaveTableDTO);
exports.LeaveTableDTO = LeaveTableDTO;
let BuyInDTO = class BuyInDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.BuyInDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buyIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], BuyInDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], BuyInDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], BuyInDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], BuyInDTO.prototype, "gameType", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Number of chips a player must put in to join / stay in a game'),
    __metadata("design:type", Number)
], BuyInDTO.prototype, "buyIn", void 0);
BuyInDTO = __decorate([
    (0, decorators_1.Describe)('Player buys in again (confirm if will be duplicated for join_table or not # of chips set in the buyin)')
], BuyInDTO);
exports.BuyInDTO = BuyInDTO;
let HandBeginDTO = class HandBeginDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.HandBeginDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "playerIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dealerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "blindPlayerIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "blindAmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], HandBeginDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], HandBeginDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], HandBeginDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], HandBeginDTO.prototype, "gameType", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('An array of the IDs for each player at the table.'),
    __metadata("design:type", Array)
], HandBeginDTO.prototype, "playerIds", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The ID for the dealer player?'),
    __metadata("design:type", String)
], HandBeginDTO.prototype, "dealerId", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('An array of the IDs for each player that has not placed chips for the current table state.'),
    __metadata("design:type", Array)
], HandBeginDTO.prototype, "blindPlayerIds", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The minimum amount required for a player to continue playing without folding.'),
    __metadata("design:type", Number)
], HandBeginDTO.prototype, "blindAmount", void 0);
HandBeginDTO = __decorate([
    (0, decorators_1.Describe)('Each player makes their first move after receiving their hand?')
], HandBeginDTO);
exports.HandBeginDTO = HandBeginDTO;
let HandDealtDTO = class HandDealtDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.HandDealtDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "handRank", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "usesNft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "handUpgradeType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ability", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chipBalance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], HandDealtDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], HandDealtDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], HandDealtDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], HandDealtDTO.prototype, "gameType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The ranking of a player's hand compared to the other players at a table"),
    __metadata("design:type", String)
], HandDealtDTO.prototype, "handRank", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('If the player is using NFTs in their hand or not?'),
    __metadata("design:type", Boolean)
], HandDealtDTO.prototype, "usesNft", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("If a player's hand rank has been upgraded due to new cards being presented in-game."),
    __metadata("design:type", String)
], HandDealtDTO.prototype, "handUpgradeType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('If a player used a special ability / item during this match.'),
    __metadata("design:type", String)
], HandDealtDTO.prototype, "ability", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The chip balance the player has on the table. (*Not in their inventory*)'),
    __metadata("design:type", Number)
], HandDealtDTO.prototype, "chipBalance", void 0);
HandDealtDTO = __decorate([
    (0, decorators_1.Describe)('A hand has been dealt to a player.')
], HandDealtDTO);
exports.HandDealtDTO = HandDealtDTO;
let HandActionDTO = class HandActionDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.HandActionDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "action", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "round", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chipBalance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isForcedAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "timerElapsed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "timerMax", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "amount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], HandActionDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], HandActionDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], HandActionDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], HandActionDTO.prototype, "gameType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enum_1.HandAction),
    (0, class_validator_1.IsIn)(Object.values(enum_1.HandAction)),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The type of action for this turn. Must be one of: <Bet, Call, Check, Fold, Raise>'),
    __metadata("design:type", String)
], HandActionDTO.prototype, "action", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enum_1.TableState),
    (0, class_validator_1.IsIn)(Object.values(enum_1.TableState)),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The current round in a poker match where this action occurred. Must be one of: <Flop, Preflop, River, Showdown, Turn, Complete>'),
    __metadata("design:type", String)
], HandActionDTO.prototype, "round", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The chip balance the player has on the table. (*Not in their inventory*)'),
    __metadata("design:type", Number)
], HandActionDTO.prototype, "chipBalance", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Was the player forced to make this action?'),
    __metadata("design:type", Boolean)
], HandActionDTO.prototype, "isForcedAction", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('How long the player took before making the action.'),
    __metadata("design:type", Number)
], HandActionDTO.prototype, "timerElapsed", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('What the maximum amount of time a player was allowed to take before making an action and automatically (check / fold?)???'),
    __metadata("design:type", Number)
], HandActionDTO.prototype, "timerMax", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The amount of chips used in this particular action?'),
    __metadata("design:type", Number)
], HandActionDTO.prototype, "amount", void 0);
HandActionDTO = __decorate([
    (0, decorators_1.Describe)('A player decides how they will play their hand for a given round.')
], HandActionDTO);
exports.HandActionDTO = HandActionDTO;
let TableStateChangeDTO = class TableStateChangeDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.TableStateChangeDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "round", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "playerIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableCards", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "winnerIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], TableStateChangeDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], TableStateChangeDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], TableStateChangeDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], TableStateChangeDTO.prototype, "gameType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enum_1.TableState),
    (0, class_validator_1.IsIn)(Object.values(enum_1.TableState)),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The current round in a poker match where this action occured. Must be one of: <Flop, Preflop, River, Showdown, Turn, Complete>'),
    __metadata("design:type", String)
], TableStateChangeDTO.prototype, "round", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The total value of chips that a particular round of poker is worth'),
    __metadata("design:type", Number)
], TableStateChangeDTO.prototype, "pot", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('An array of the IDs for each player at the table.'),
    __metadata("design:type", Array)
], TableStateChangeDTO.prototype, "playerIds", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => game_related_1.PlayingCard),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, decorators_1.Describe)('An array of PlayingCard objects for each card that is currently shown on the table'),
    __metadata("design:type", Array)
], TableStateChangeDTO.prototype, "tableCards", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('An array of the IDs for each player that won at the table.'),
    __metadata("design:type", Array)
], TableStateChangeDTO.prototype, "winnerIds", void 0);
TableStateChangeDTO = __decorate([
    (0, decorators_1.Describe)("A particular poker table's state changes.")
], TableStateChangeDTO);
exports.TableStateChangeDTO = TableStateChangeDTO;
let HandDeltaDTO = class HandDeltaDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.HandDeltaDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cards", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dealerCards", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chipValueDelta", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], HandDeltaDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], HandDeltaDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], HandDeltaDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], HandDeltaDTO.prototype, "gameType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enum_1.HandDeltaReason),
    (0, class_validator_1.IsIn)(Object.values(enum_1.HandDeltaReason)),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The reason a player's chip balance has changed due to a player taking a turn. Must be one of: <Loss, Tie, Win>"),
    __metadata("design:type", String)
], HandDeltaDTO.prototype, "reason", void 0);
__decorate([
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.PlayingCard, minSize: 1 }),
    (0, decorators_1.Describe)("An array of PlayingCard objects for the current player's hand?"),
    __metadata("design:type", Array)
], HandDeltaDTO.prototype, "cards", void 0);
__decorate([
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.PlayingCard, minSize: 0 }),
    (0, decorators_1.Describe)("An array of PlayingCard objects for the table's dealer."),
    __metadata("design:type", Array)
], HandDeltaDTO.prototype, "dealerCards", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)("How much the player's chip balance has changed. (Plus or Minus)"),
    __metadata("design:type", Number)
], HandDeltaDTO.prototype, "chipValueDelta", void 0);
HandDeltaDTO = __decorate([
    (0, decorators_1.Describe)("A player's chip balance changes due to new cards being added to their hand.")
], HandDeltaDTO);
exports.HandDeltaDTO = HandDeltaDTO;
let TableGiftDTO = class TableGiftDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.TableGiftDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "giftedToIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "receivedFromIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chipValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], TableGiftDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], TableGiftDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], TableGiftDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], TableGiftDTO.prototype, "gameType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The item a player has (sent or received?)'),
    __metadata("design:type", String)
], TableGiftDTO.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('An array of player IDs that the gift was sent to?'),
    __metadata("design:type", Array)
], TableGiftDTO.prototype, "giftedToIds", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('An array of player IDs that the gift was received from? (Should this be an array?)'),
    __metadata("design:type", Array)
], TableGiftDTO.prototype, "receivedFromIds", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The value of chips included in a particular gift'),
    __metadata("design:type", Number)
], TableGiftDTO.prototype, "chipValue", void 0);
TableGiftDTO = __decorate([
    (0, decorators_1.Describe)('A player (sends or receives?) a gift from the table?')
], TableGiftDTO);
exports.TableGiftDTO = TableGiftDTO;
let TableMessageDTO = class TableMessageDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.TableMessageDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chipValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], TableMessageDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], TableMessageDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], TableMessageDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], TableMessageDTO.prototype, "gameType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The item included in the message?'),
    __metadata("design:type", String)
], TableMessageDTO.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The content of the message (sent or received?)'),
    __metadata("design:type", String)
], TableMessageDTO.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The value of chips included in a message.'),
    __metadata("design:type", Number)
], TableMessageDTO.prototype, "chipValue", void 0);
TableMessageDTO = __decorate([
    (0, decorators_1.Describe)('A player sends a message to another player at the table.')
], TableMessageDTO);
exports.TableMessageDTO = TableMessageDTO;
let ChipPurchaseDTO = class ChipPurchaseDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.ChipPurchaseDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "price", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "txnId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gameType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('How much a player spent on chips'),
    __metadata("design:type", Number)
], ChipPurchaseDTO.prototype, "price", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The reason a player purchased chips?'),
    __metadata("design:type", String)
], ChipPurchaseDTO.prototype, "reason", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The blockchain transaction Id for this purchase of a chip pack'),
    __metadata("design:type", String)
], ChipPurchaseDTO.prototype, "txnId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('RoomId for a given tournament room.'),
    __metadata("design:type", String)
], ChipPurchaseDTO.prototype, "roomId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The table identifier.'),
    __metadata("design:type", String)
], ChipPurchaseDTO.prototype, "tableId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)("The name of the game, e.g. Texas Hold'em"),
    __metadata("design:type", String)
], ChipPurchaseDTO.prototype, "gameName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)("The type of the game, e.g. Sit 'n Go, Cash Game, Tournament"),
    __metadata("design:type", String)
], ChipPurchaseDTO.prototype, "gameType", void 0);
ChipPurchaseDTO = __decorate([
    (0, decorators_1.Describe)('A player purchases a chip pack from inside the game.')
], ChipPurchaseDTO);
exports.ChipPurchaseDTO = ChipPurchaseDTO;
let TicketBalanceChangeDTO = class TicketBalanceChangeDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.TicketBalanceChangeDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "ticketDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "txnId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "oldBalance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "newBalance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The details of why a player's ticket balance changed?"),
    __metadata("design:type", String)
], TicketBalanceChangeDTO.prototype, "ticketDetails", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The reason a player's ticket balance changed."),
    __metadata("design:type", String)
], TicketBalanceChangeDTO.prototype, "reason", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)("The blockchain transaction Id that resulted in a user's ticket balance change"),
    __metadata("design:type", String)
], TicketBalanceChangeDTO.prototype, "txnId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The chip balance of a plyer prior to when the balance changed'),
    __metadata("design:type", String)
], TicketBalanceChangeDTO.prototype, "oldBalance", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('The new chip balance for a plyer after the balance change has occurred'),
    __metadata("design:type", String)
], TicketBalanceChangeDTO.prototype, "newBalance", void 0);
TicketBalanceChangeDTO = __decorate([
    (0, decorators_1.Describe)("A player's raffle ticket balance changes.")
], TicketBalanceChangeDTO);
exports.TicketBalanceChangeDTO = TicketBalanceChangeDTO;
let ChipResetDTO = class ChipResetDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.ChipResetDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "chipsDistributed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('How many chips were distributed to players during the reset'),
    __metadata("design:type", Number)
], ChipResetDTO.prototype, "chipsDistributed", void 0);
ChipResetDTO = __decorate([
    (0, decorators_1.Describe)('Daily chip reset happens.')
], ChipResetDTO);
exports.ChipResetDTO = ChipResetDTO;
let PokerLeaderboardDTO = class PokerLeaderboardDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.PokerLeaderboardDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "position", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "handsPlayed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "handsWon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chipsWon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "timePlayed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stack", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The Id of the player that is sending this leaderboard event.'),
    __metadata("design:type", String)
], PokerLeaderboardDTO.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The position of the current player on the leaderboard that is passing this event.)'),
    __metadata("design:type", Number)
], PokerLeaderboardDTO.prototype, "position", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('How many hands that player has played during this current leaderboard.'),
    __metadata("design:type", Number)
], PokerLeaderboardDTO.prototype, "handsPlayed", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('How many hands that player has won during this current leaderboard.'),
    __metadata("design:type", Number)
], PokerLeaderboardDTO.prototype, "handsWon", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('How many chips that player has won during this current leaderboard.'),
    __metadata("design:type", Number)
], PokerLeaderboardDTO.prototype, "chipsWon", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The time played during this leaderboard'),
    __metadata("design:type", Number)
], PokerLeaderboardDTO.prototype, "timePlayed", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The position of the current player on the leaderboard that is passing this event.'),
    __metadata("design:type", Number)
], PokerLeaderboardDTO.prototype, "stack", void 0);
PokerLeaderboardDTO = __decorate([
    (0, decorators_1.Describe)('Once a day event with the final leaderboard and all of its stats.')
], PokerLeaderboardDTO);
exports.PokerLeaderboardDTO = PokerLeaderboardDTO;
